import Btn from "../../../../components/buttons/Btn";
import SearchSelect from "./../../../../components/inputs/SearchSelect";
import { findProdutos } from "../../../../repositories/qerpapi/erp/estoque/v1/ProdutosRepository";
import { validNotNull } from "../../../../utils/validations";
import { useCallback, useContext, useEffect, useState } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { ProdutoContext } from "../contexts/ProdutoContext";
import { notify } from "../../../../utils/notify";
import SearchDialog from "../../../../patterns/modals/SearchDialog";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { IconCustom } from "../styles/Produto";

let typingTimer = null;
export const ModalSearchSelect = ({
  open = false,
  setOpen = () => {},
  handleAdd = () => {},
  rowEdit = null,
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const { setLoading, transformationProducts } = useContext(ProdutoContext);

  const [errors, setErrors] = useState({});
  const [openSearchDialog, setOpenSearchDialog] = useState(false);
  const [disabledInputs, setDisabledInputs] = useState(!!rowEdit);

  const [barCode, setBarCode] = useState("");
  const [auxBarCode, setAuxBarCode] = useState("");
  const [product, setProduct] = useState(!!rowEdit ? { ...rowEdit } : null);
  const [factorTransformation, setFactorTransformation] = useState(
    rowEdit?.fator ?? "0,00"
  );

  const productModalColumns = [
    {
      label: "CÓD.",
      id: "id",
    },
    {
      label: "CÓD. BARRAS",
      id: "codigobarras",
    },
    {
      label: "Produto",
      id: "descricao",
    },
  ];

  useEffect(() => {
    if (!product?.codigobarras) return;

    setBarCode(product.codigobarras);
  }, [product]);

  useEffect(() => {
    clearTimeout(typingTimer);

    typingTimer = setTimeout(async () => {
      setLoading(true);
      try {
        if (auxBarCode) {
          const callback = await findProdutos({
            empresa_cnpj: queryParams.empresa_cnpj,
            where: {
              "%codigobarras%": auxBarCode,
            },
          });

          if (callback?.data && callback.data[0]) {
            setProduct(callback.data[0]);
          } else {
            setProduct(null);
            notify(
              `Nenhum produto encontrado com o código de barras ${auxBarCode}`
            );
          }
        }
      } catch (e) {
        console.log("Erro na requisição do código de barras: ", e);
      } finally {
        setLoading(false);
      }
    }, 1500);
  }, [auxBarCode, queryParams.empresa_cnpj, setLoading, setProduct]);

  const handleCloseModal = () => {
    setDisabledInputs(false);
    setOpen(false);
  };

  const handleSaveClick = () => {
    const errors = validNotNull([{ key: "product", value: product }]);

    setErrors({ ...errors });

    if (errors.error) return notify("Um produto precisa ser selecionado.");

    if (!rowEdit) {
      for (const listItem of transformationProducts) {
        if (listItem.id === product.id) {
          errors.error = true;
          errors.errorsValidation.product = "Produto já utilizado.";
          setErrors({ ...errors });

          return notify(
            "Um fator de conversão já foi atribuído a este produto."
          );
        }
      }
    }

    const selectedProduct = {
      id: product.id,
      codigobarras: product.codigobarras,
      descricao: product.descricao,
      fator: factorTransformation,
    };

    handleAdd(selectedProduct);
  };

  const handleChangeBarcode = useCallback(
    (e) => {
      setAuxBarCode(e.target.value);
      setBarCode(e.target.value);
    },
    [setAuxBarCode, setBarCode]
  );

  const handleSelectProduct = (setOpen, selected) => {
    setProduct(selected[0]);

    setOpen(false);
  };

  return (
    <>
      {openSearchDialog && (
        <>
          <SearchDialog
            open={openSearchDialog}
            setOpen={setOpenSearchDialog}
            columns={productModalColumns}
            selectable={true}
            multiSelect={false}
            handleMainClick={handleSelectProduct}
            route="estoque/produtos/v1"
            title="PRODUTOS"
          />
        </>
      )}
      <Dialog
        open={open}
        fullWidth
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Busque pelo produto desejado
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Procure pelo código de barras ou pela descrição e adicione um fator
            de transformação.
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextFieldErp
                label="CÓD. BARRAS"
                value={barCode}
                onChange={handleChangeBarcode}
                helperText={errors?.errorsValidation?.product || ""}
                error={!!errors.error}
                disabled={disabledInputs}
              />
            </Grid>
            <Grid item xs={!disabledInputs ? 5 : 6}>
              <SearchSelect
                label="Descrição"
                value={product}
                setValue={setProduct}
                route="estoque/produtos/v1"
                filter="descricao,descricaoresumida"
                helperText={errors?.errorsValidation?.product || ""}
                error={!!errors?.error}
                disabled={disabledInputs}
              />
            </Grid>
            {!disabledInputs && (
              <Grid item xs={1}>
                <Btn
                  label={<IconCustom>search</IconCustom>}
                  bgcolor="blue"
                  hovercolor="primary"
                  full="true"
                  onClick={() => setOpenSearchDialog(true)}
                  sameWidth
                  disabled={disabledInputs}
                />
              </Grid>
            )}
            <Grid item xs={3}>
              <TextFieldErp
                label="Fator"
                maxLength={120}
                value={factorTransformation}
                setValue={setFactorTransformation}
                mask="decimal"
                decimals={5}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn label="Cancelar" bgcolor="tertiary" onClick={handleCloseModal} />
          <Btn label="Salvar" onClick={handleSaveClick} />
        </DialogActions>
      </Dialog>
    </>
  );
};
